import { OrderData, PropelUserModel } from '../api';

export const findUserById = (users: PropelUserModel[], user_id: string) => {
  return users?.find((user) => user.user_id === user_id);
};

export const orderMatchesSearch = (order: OrderData, query: string): boolean => {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  const haystack = [
    order.firstname,
    order.lastname,
    order.email,
    order.phone,
    order.order_number != null ? String(order.order_number) : '',
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return haystack.includes(needle);
};

export const getEmployeeNames = (employee_ids: string[], users: PropelUserModel[]): string[] => {
  const employees = employee_ids.map((id) => {
    const user = findUserById(users, id);
    if (user) {
      return `${user.first_name}`; // ${user.last_name}
    }
    return null;
  });
  return employees.filter((x) => x !== null) as string[];
};
